class CelliniHeroSlider extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-cellini-slide]')];
    this.dots = [...this.querySelectorAll('[data-cellini-go]')];
    this.current = this.slides.findIndex((slide) => !slide.hidden);
    if (this.current < 0) this.current = 0;
    if (this.slides.length < 2) return;

    this.querySelector('[data-cellini-prev]')?.addEventListener('click', () => this.show(this.current - 1));
    this.querySelector('[data-cellini-next]')?.addEventListener('click', () => this.show(this.current + 1));
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.celliniGo))));

    let startX = null;
    this.addEventListener('touchstart', (event) => {
      startX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    this.addEventListener('touchend', (event) => {
      if (startX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? startX) - startX;
      startX = null;
      if (Math.abs(distance) < 55) return;
      const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      this.show(this.current + (distance < 0 ? direction : -direction));
    }, { passive: true });

    this.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-cellini-slide]');
      const index = this.slides.indexOf(slide);
      if (index >= 0) this.show(index);
    });
  }

  show(index) {
    if (!this.slides?.length) return;
    this.current = ((index % this.slides.length) + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, position) => {
      const active = position === this.current;
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.dots.forEach((dot, position) => {
      if (position === this.current) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    const count = this.querySelector('[data-cellini-current]');
    if (count) count.textContent = String(this.current + 1).padStart(2, '0');
  }
}

if (!customElements.get('cellini-hero-slider')) {
  customElements.define('cellini-hero-slider', CelliniHeroSlider);
}
